import React from 'react';
import Member from './member';
import EmailOnlyMember from './email_only_member';

const MemberList = ({
  members,
  tab,
  setMember,
  handleModalOpen,
  communityId,
  setUpdatedMember,
  blankHeadshot,
  admin
}) => {
  const createMemberList = (members) => {
    return members.length > 0 ? (
      members.map((member) => {
        if (typeof member === 'string') {
          return <EmailOnlyMember member={member} key={`${tab}-${member}`} blankHeadshot={blankHeadshot} />;
        }
        return <Member
          key={`${tab}-${member.id}`}
          member={member}
          setMember={setMember}
          handleModalOpen={handleModalOpen}
          tab={tab}
          communityId={communityId}
          setUpdatedMember={setUpdatedMember}
          admin={admin}
        />;
       })
    ) : (
      <p className="h5 text-center">No results match your search</p>
    );
  };

  return (
    <div className="member-cards">{createMemberList(members)}</div>
  );
};

export default MemberList;
